var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 38",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6663 5.24935H12.0001C8.78429 5.24935 6.167 7.9911 6.167 11.3608V20.527C6.167 23.8976 8.78429 26.6384 12.0001 26.6384H23.6663V34.277C23.6663 35.9572 22.3533 37.3327 20.7493 37.3327H3.24956C1.64646 37.3327 0.333008 35.9572 0.333008 34.277V3.72127C0.333008 2.04193 1.64646 0.666016 3.24956 0.666016H20.7493C22.3533 0.666016 23.6663 2.04193 23.6663 3.72127V5.24935ZM14.1877 32.3676C14.1877 31.7378 13.6955 31.2217 13.0939 31.2217H10.9063C10.3056 31.2217 9.81247 31.7378 9.81247 32.3676C9.81247 32.9968 10.3056 33.5134 10.9063 33.5134H13.0939C13.6955 33.5134 14.1877 32.9968 14.1877 32.3676ZM11.444 8.99935H30.8882C32.4158 8.99935 33.6663 10.2001 33.6663 11.6665V19.6659C33.6663 21.1323 32.4158 22.3327 30.8882 22.3327H11.444C9.91642 22.3327 8.66634 21.1323 8.66634 19.6659V11.6665C8.66634 10.2001 9.91642 8.99935 11.444 8.99935ZM22.5544 11.6665H12.1382V13.6665H22.5544V11.6665ZM12.1382 18.3328H15.611V16.3328H12.1382V18.3328ZM17.6944 18.3328H25.3325V16.3328H17.6944V18.3328ZM28.1106 19.6659H30.194V11.6665H26.7213V12.9993L28.1106 13.6665V19.6659Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneNotification);
export default __webpack_public_path__ + "static/media/phone-notification.7b49442d25f34493766fdbd51317788f.svg";
export { ForwardRef as ReactComponent };